import uuid from 'uuid';

import type { Pet } from '@rover/types';
import { PetType } from '@rover/types/src/Pet';

export const PET_DEFAULTS: Pet = {
  pk: '',
  id: '',
  url: '',
  name: '',
  weight: '',
  breeds: [],
  ageYears: '',
  ageMonths: '',
  gender: '',
  isPuppy: false,
  defaultImage: {
    caption: '',
    small: 'https://www.rover.com/static/images/profilable/defaults/big_thumb.png',
    medium: '',
    wide: '',
    wideRetina: '',
    largeUncropped: '',
    largeUncroppedRetina: '',
    bigThumb: 'https://www.rover.com/static/images/profilable/defaults/big_thumb.png',
    isFallback: true,
    originalHeight: 100,
    originalWidth: 100,
    index: 1,
    orientation: 'portrait',
    url: '',
    urls: {
      ordering: '',
    },
  },
  petType: PetType.DOG,
  weightObj: [],
  owner: '',
  webUrl: '',
  urls: {
    images: '',
  },
  active: true,
  dogSize: '',
  careInstructions: '',
  veterinaryInformation: '',
  insuranceProvider: null,
  emergencyContactInformation: '',
  birthday: '',
  adoptionDate: null,
  birthdayDisplay: '',
  implant: null,
  spayedNeutered: null,
  description: null,
  specialRequirements: null,
  houseTrained: null,
  houseTrainedDesc: null,
  playsChildren: null,
  playsChildrenDesc: null,
  playsDogs: null,
  playsDogsDesc: null,
  playsCats: null,
  playsCatsDesc: null,
  notes: null,
  petDetails: [],
  isMemorialized: null,
  memorialDate: null,
};

export default function petFactory(opts?: Partial<Pet>): Pet {
  return { ...PET_DEFAULTS, id: uuid.v4(), ...opts };
}
